import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { ArrowDown, Heart } from "lucide-react";
const NewPageHero = () => {
  const {
    language
  } = useLanguage();
  const content = {
    fr: {
      eyebrow: "Des preuves d'amour à l'épreuve du temps",
      headline: "Des preuves d'amour à l'épreuve du temps",
      subHeadline1: "Pas un jouet. Pas un simple compte.",
      subHeadline2: "Anniversaires, Noel, réussites scolaires, un enfant reçoit en moyenne 7000€ de cadeaux éphémères avant sa majorité.",
      subHeadline3: "Et si la moitié était investie pour préparer l'avenir de votre enfant ?",
      createLegacy: "Créer leur cagnotte cadeau",
      howItWorks: "Comment ça marche",
      bannerText: "Un cadeau qui grandit avec le temps",
      trustText: "Déjà 1000+ familles nous font confiance"
    },
    en: {
      eyebrow: "A presence that transcends time",
      headline: "The most meaningful gift you can give",
      subHeadline1: "A growing gift — not just another toy",
      subHeadline2: "With Legatia, you're giving more than money: you're gifting dreams, memories, and a future.",
      subHeadline3: "Better than toys. Better than a basic savings account. A true gift.",
      createLegacy: "Create their gift",
      howItWorks: "How it works",
      bannerText: "A gift that grows with time",
      trustText: "Already 1000+ families trust us"
    },
    de: {
      eyebrow: "Eine Präsenz, die die Zeit überdauert",
      headline: "Das bedeutungsvollste Geschenk, das Sie machen können",
      subHeadline1: "Ein wachsendes Geschenk — nicht nur ein weiteres Spielzeug",
      subHeadline2: "Mit Legatia schenken Sie mehr als Geld: Sie schenken Träume, Erinnerungen und eine Zukunft.",
      subHeadline3: "Besser als Spielzeug. Besser als ein einfaches Sparkonto. Ein wahres Geschenk.",
      createLegacy: "Ihr Geschenk schaffen",
      howItWorks: "Wie es funktioniert",
      bannerText: "Ein Geschenk, das mit der Zeit wächst",
      trustText: "Bereits 1000+ Familien vertrauen uns"
    }
  };
  const textContent = content[language];
  return <section className="relative pt-20 pb-12 md:pt-32 md:pb-20 lg:pt-40 lg:pb-28 px-4 bg-gradient-to-br from-legatia-light via-white to-gray-50 overflow-hidden">
      {/* Simplified decorative elements */}
      <div className="absolute top-20 right-[10%] w-64 h-64 bg-gradient-to-r from-legatia-orange/15 to-legatia-yellow/15 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 left-[5%] w-48 h-48 bg-gradient-to-r from-legatia-yellow/10 to-legatia-green/10 rounded-full blur-xl"></div>
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 xl:gap-16 items-center">
          <div className="order-2 lg:order-1 space-y-4 md:space-y-6">
            <h1 className="text-2xl md:text-3xl lg:text-6xl xl:text-7xl leading-tight text-orange-500 font-bold text-center lg:text-center">
              {textContent.headline}
            </h1>
            
            <div className="space-y-3 md:space-y-4">
              <p className="text-lg md:text-xl lg:text-2xl text-gray-700 font-medium text-center">
                {textContent.subHeadline2}
              </p>
              
              <p className="text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed">
                {textContent.subHeadline3}
              </p>
            </div>
            
            <div className="flex flex-col gap-3 pt-4 md:flex-row md:gap-4">
              <Button className="group bg-gradient-to-r from-legatia-orange to-legatia-red hover:from-legatia-orange/90 hover:to-legatia-red/90 text-white px-6 py-4 md:px-8 md:py-6 rounded-2xl transition-all transform hover:shadow-xl hover:-translate-y-1 text-base md:text-lg font-semibold shadow-lg w-full md:w-auto" onClick={() => window.location.href = "https://app.getlegatia.ch/"}>
                <Heart className="mr-2 h-4 w-4 md:h-5 md:w-5 group-hover:scale-110 transition-transform" />
                {textContent.createLegacy}
              </Button>
              
              <Button variant="outline" className="border-2 border-legatia-orange text-legatia-orange hover:bg-legatia-orange/5 px-6 py-4 md:px-8 md:py-6 rounded-2xl flex items-center justify-center gap-2 font-medium transition-all hover:shadow-lg text-base md:text-lg w-full md:w-auto" onClick={() => {
              document.getElementById("how-it-works")?.scrollIntoView({
                behavior: "smooth"
              });
            }}>
                {textContent.howItWorks}
                <ArrowDown className="h-4 w-4" />
              </Button>
            </div>
          </div>
          
          <div className="order-1 lg:order-2">
            <div className="relative group">
              {/* Simplified shadow effects */}
              <div className="absolute inset-0 bg-gradient-to-br from-legatia-orange/30 to-legatia-yellow/30 rounded-3xl transform translate-x-2 translate-y-2"></div>
              
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
                <img src="/lovable-uploads/8ba0af71-ff9f-4a0d-903b-27a7c9e31c38.png" alt="Graduate with childhood toys transforming into future assets" className="w-full h-full object-cover aspect-[4/3]" loading="eager" decoding="async" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default NewPageHero;